module.exports = __webpack_public_path__ + "static/media/Type1Icon.2b24fd08.png";